'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerPrice = renderWithRef('BannerPrice', null, (n, o)=>{
    let { children: t } = n;
    return jsx(RenderComp, {
        root: "p",
        forwardedRef: o,
        classNames: [
            'swan-banner-price'
        ],
        props: n,
        children: t
    });
});

export { BannerPrice };
